import styles from "./InclusionHoverTip.module.css";
import { getInclusionTip } from "@/utils/Inclusions";

export default function InclusionHoverTip({
  id,
  item,
  label,
  className = "",
  children,
}) {
  const tip = getInclusionTip(id, item, label);
  const hasTip = Boolean(tip.heading || tip.label);

  return (
    <span className={`${styles.wrap} ${className}`.trim()}>
      {hasTip ? (
        <span className={styles.tip} role="tooltip">
          {/* {tip.heading ? <span className={styles.heading}>{tip.heading}</span> : null} */}
          {tip.label ? <span className={styles.label}>{tip.label}</span> : null}
        </span>
      ) : null}
      {children}
    </span>
  );
}